import { useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
//Icons
import { FaPhoneAlt } from 'react-icons/fa';
//Utils
import { RenderIf } from '../../utils/RenderIf';
import { ClearPhone } from '../../utils/ClearPhone';



function ModalYappyBtn({ showModal, setShowModal, nextStepYappy, phone }) {

    //Ref for yappy button
    const yappyBtnRef = useRef(null);
    //Refs
    const phoneClientYappy = useRef(null);

    // <btn-yappy> is a custom element defined by a remote module script (public/index.html, loaded
    // from Yappy's own CDN) - it can still be fetching/executing by the time this modal opens on a
    // slow connection. Until customElements.whenDefined resolves, the browser treats <btn-yappy> as
    // an unrecognized element: no button, no visible content, just the "Cancelar" button below it -
    // which is exactly what was reported (button missing on some phones, present on others, tied to
    // how fast that script happened to load rather than anything about the device itself). Checked
    // synchronously first so a customer's second payment attempt in the same session (element already
    // defined from the first) never shows the loading state at all.
    const [yappyReady, setYappyReady] = useState(
        () => typeof customElements !== 'undefined' && Boolean(customElements.get('btn-yappy'))
    );

    useEffect(() => {
        if (yappyReady || typeof customElements === 'undefined') return;
        let cancelled = false;
        customElements.whenDefined('btn-yappy').then(() => {
            if (!cancelled) setYappyReady(true);
        });
        return () => { cancelled = true; };
    }, [yappyReady]);

    //Use effect to handle the Yappy button events
    useEffect(() => {
        const btnYappy = yappyBtnRef.current;
        // Yappy's aliasYappy expects a bare 8-digit Panama number - strip dashes/spaces (the
        // placeholder below literally shows "6000-0000") and any "+507"/"507" prefix before this
        // ever reaches the backend, instead of forwarding whatever the customer typed verbatim and
        // having Yappy reject it as an opaque 400 later.
        const getPhoneValue = () => ClearPhone(phoneClientYappy.current?.value || phone || "");


        //We check the yappy button 
        if (btnYappy !== null && btnYappy !== undefined) {

            //This is for the event yappy btn success
            const handleSuccess = (e) => {
                //setShowModalPhone(false); // Cierra el modal

                nextStepYappy(btnYappy, getPhoneValue(), "success", e.detail);
            };

            //This is for the event yappy btn error
            const handleError = (e) => {

                nextStepYappy(btnYappy, getPhoneValue(), e.detail, 0);
            };

            //This is for the event of the click 
            const handleClick = async (e) => {
                nextStepYappy(btnYappy, getPhoneValue(), "create", 0);
            };

            const handlePayment = (e) => {

            };

            btnYappy.addEventListener("eventSuccess", handleSuccess);
            btnYappy.addEventListener("eventError", handleError);
            btnYappy.addEventListener("eventClick", handleClick);
            btnYappy.addEventListener("eventPayment", handlePayment);

            return () => {
                btnYappy.removeEventListener("eventSuccess", handleSuccess);
                btnYappy.removeEventListener("eventError", handleError);
                btnYappy.removeEventListener("eventClick", handleClick);
                btnYappy.removeEventListener("eventPayment", handlePayment);
            };
        }

    }, [showModal, nextStepYappy, phone])



    return (
        <>

            {/*input phone client */}
            <Modal
                id='modal-phone-yappy'
                show={showModal}
                fullscreen
                onHide={() => setShowModal(false)}
                aria-labelledby="ypy-title"
                centered
                contentClassName="ypy-modal-content"
            >

                {/* <Modal.Header className='border-0'>
                    <strong className=''> YAPPY </strong>
                </Modal.Header> */}
                <Modal.Body className='section-message-yappy ypy-modal-body'>

                    {/* Fondo animado (decorativo) */}
                    <div className="ypy-bg" aria-hidden="true">
                        <span className="ypy-blob ypy-blob--1"></span>
                        <span className="ypy-blob ypy-blob--2"></span>
                        <span className="ypy-blob ypy-blob--3"></span>
                        <span className="ypy-blob ypy-blob--4"></span>
                        <span className="ypy-blob ypy-blob--5"></span>
                    </div>

                    <main className="ypy-page">
                        <section className="ypy-card">

                            <header className="ypy-head">
                                <div className="ypy-method">
                                    <span className="ypy-method-logo">
                                        <img src="https://cascoyogapanama.com/wp-content/uploads/2020/05/yappy-BIG-Logo.png" alt="Yappy" />
                                    </span>
                                    <div className="ypy-method-text">
                                        <span className="ypy-eyebrow">Método de pago</span>
                                        <span className="ypy-merchant">Yappy</span>
                                    </div>
                                </div>

                                <h2 className="ypy-title" id="ypy-title">
                                    Ingresa tu número de teléfono
                                </h2>
                                <p className="ypy-lead">
                                    Te enviaremos una solicitud de pago a tu app de Yappy para que la apruebes.
                                </p>
                            </header>

                            <div className="ypy-body">
                                <div className="ypy-field">
                                    <label className="ypy-label" htmlFor="ypy-phone">Número de teléfono</label>
                                    <div className="ypy-input-wrap">
                                        <span className="ypy-prefix" aria-hidden="true">+507</span>
                                        <input
                                            id="ypy-phone"
                                            type="tel"
                                            inputMode="numeric"
                                            autoComplete="tel-national"
                                            className="ypy-input"
                                            ref={phoneClientYappy}
                                            defaultValue={phone}
                                            placeholder='6000-0000'
                                        />
                                    </div>
                                    <p className="ypy-help">
                                        <i className="uil uil-info-circle" aria-hidden="true"></i>
                                        <span>Usa el número celular registrado en Yappy (8 dígitos).</span>
                                    </p>
                                </div>

                                <div className="ypy-actions">
                                    <RenderIf isTrue={showModal !== false && yappyReady}>
                                        {/** For btn yappy order */}
                                        <div className="ypy-official">
                                            <btn-yappy theme="blue"
                                                id={`yappy-btn`}
                                                ref={yappyBtnRef}
                                                className="btn btn-lg"
                                                phone={phone || ""}
                                            ></btn-yappy>
                                        </div>
                                    </RenderIf>

                                    <RenderIf isTrue={showModal !== false && !yappyReady}>
                                        <button className="ypy-btn ypy-btn-primary" type="button" disabled aria-busy="true">
                                            <span className="ypy-spin" aria-hidden="true"></span>
                                            Cargando Yappy...
                                        </button>
                                    </RenderIf>

                                    <button type="button" className="ypy-btn ypy-btn-quiet" onClick={() => setShowModal(false)}>
                                        Cancelar
                                    </button>
                                </div>
                            </div>

                            <footer className="ypy-foot">
                                <i className="uil uil-lock" aria-hidden="true"></i>
                                Pago procesado de forma segura por Yappy
                            </footer>
                        </section>
                    </main>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ModalYappyBtn
